/** Matches "HH:MM" or "HH:MM:SS" — the two shapes shift times arrive in. */
const TIME_PATTERN = /^(\d{1,2}):(\d{2})(?::(\d{2}))?$/;

/**
 * Convert a shift time to seconds since midnight, or null when it is not a
 * value we can compare.
 */
export function parseShiftTimeToSeconds(value: string | null | undefined): number | null {
  if (typeof value !== 'string') return null;

  const match = TIME_PATTERN.exec(value.trim());
  if (!match) return null;

  const hours = Number(match[1]);
  const minutes = Number(match[2]);
  const seconds = match[3] === undefined ? 0 : Number(match[3]);
  if (hours > 23 || minutes > 59 || seconds > 59) return null;

  return hours * 3600 + minutes * 60 + seconds;
}

/**
 * True when the end time is not strictly after the start time.
 *
 * The API returns Postgres `time` values as "HH:MM:SS" while <input type="time">
 * emits "HH:MM", so an edited field and an untouched one carry different shapes.
 * Comparing the raw strings ranked "16:00:00" below "16:00" and let an equal
 * start/end pair save (CWL-178) — compare seconds instead.
 *
 * Returns false when either value is absent or unparseable; an incomplete form is
 * handled by the existing required-field checks, not by this guard.
 */
export function isEndNotAfterStart(
  startTime: string | null | undefined,
  endTime: string | null | undefined,
): boolean {
  const start = parseShiftTimeToSeconds(startTime);
  const end = parseShiftTimeToSeconds(endTime);
  if (start === null || end === null) return false;

  return end <= start;
}
